import React, { useState } from 'react'
import { Button, Col, Form, Row } from 'react-bootstrap'
import ImageUploadComponent from '../../ImageUploadComponent/ImageUploadComponent'
import { ImSpinner3 } from 'react-icons/im';
import ReactSelectOption from '../../SelectOptions/ReactSelectOption';
import { DOCUMENT_TYPES } from '../../../Constants/MainKeys';
import ApiService from '../../../Services/ApiService';
import AlertService from '../../../Services/AlertService';

export default function FileUploadComponent({ setIsShowLoader, setStepNumber, sessionId }) {

  const [isLoading, setIsLoading] = useState(false);
  const [documentType, setDocumentType] = useState(null);
  const [isInvalidSubmit, setIsInvalidSubmit] = useState(null);


  const [values, setValues] = useState({
    uploadedFile_1: null,
    uploadedFile_2: null,
    uploadedFile_3: null,
  })

  const onUploadFile = (file, field) => {
    setValues((prev) => ({
      ...prev,
      [field]: file[0]
    }))
    setIsInvalidSubmit(false);
  }

  const onSubmit = (event) => {
    event && event.preventDefault();
    if (!sessionId) { return false; }
    if (!documentType || !values.uploadedFile_1 || !values.uploadedFile_2 || !values.uploadedFile_3) {
      setIsInvalidSubmit(true);
      return false;
    }
    setIsLoading(true);
    const formData = new FormData();
    formData.append("sessionId", sessionId);
    formData.append("FrontImage", values.uploadedFile_1.file);
    formData.append("BackImage", values.uploadedFile_2.file);
    formData.append("SelfieImage", values.uploadedFile_3.file);
    ApiService.fileUploadVeriff(formData).then(() => {
      setIsLoading(false);
    }).catch(error => AlertService.alert("error", error))
  }

  return (
    <Form onSubmit={onSubmit} className='py-2'>
      <Row>
        <Col sm={12}>
          <h5>Upload Files Here</h5>
          <hr />
        </Col>


        <Col sm={12}>
          <Form.Group className="mb-3" controlId="formCountry">
            <Form.Label>Document type*</Form.Label>
            <ReactSelectOption
              value={documentType}
              className={`veriff-modal-select-option ${isInvalidSubmit && !documentType ? "error-border" : ""}`}
              isSearchable={true}
              menuPlacement="bottom"
              selectedValue={(() => {
                const selectedValue = DOCUMENT_TYPES.find(data => data.id === documentType);
                return selectedValue ? { label: selectedValue.name, value: selectedValue.id } : null;
              })()}
              items={DOCUMENT_TYPES.map(data => ({ label: data.name, value: data.id }))}
              onChange={(item) => setDocumentType(item.value)}
            />
          </Form.Group>
        </Col>
        <Col xl={4} className='mt-2 mt-xl-0'>
          <div className='border rounded p-2 mt-3 mt-xl-0 h-100'>
            <div className='p-2'>
              <p className='text-center' style={{ fontWeight: "500" }}>Upload document front side</p>
              {
                values.uploadedFile_1 ?
                  <div>
                    <div className='d-flex justify-content-center position-relative'>
                      <img src={values.uploadedFile_1.uploadedFile} className='rounded' height={150} />
                    </div>
                    <div className='d-flex justify-content-center mt-3 mb-2'>
                      <Button size='sm' className=' px-3' variant='danger'
                        onClick={() => {
                          setValues(values => ({ ...values, uploadedFile_1: null }))
                        }}
                      >
                        Remove
                      </Button>
                    </div>
                  </div>
                  : <ImageUploadComponent
                    cb={onUploadFile}
                    field='uploadedFile_1'
                  />
              }
            </div>
          </div>
        </Col>
        <Col xl={4} className='mt-2 mt-xl-0'>
          <div className='border rounded p-2 mt-3 mt-xl-0 h-100'>
            <div className='p-2'>
              <p className='text-center' style={{ fontWeight: "500" }}>Upload document back side</p>
              {
                values.uploadedFile_2 ?
                  <div>
                    <div className='d-flex justify-content-center position-relative'>
                      <img src={values.uploadedFile_2.uploadedFile} className='rounded' height={150} />
                    </div>
                    <div className='d-flex justify-content-center mt-3 mb-2'>
                      <Button size='sm' className=' px-3' variant='danger'
                        onClick={() => {
                          setValues(values => ({ ...values, uploadedFile_2: null }))
                        }}
                      >
                        Remove
                      </Button>
                    </div>
                  </div>
                  : <ImageUploadComponent
                    cb={onUploadFile}
                    field='uploadedFile_2'
                  />
              }
            </div>
          </div>
        </Col>
        <Col xl={4} className='mt-2 mt-xl-0'>
          <div className='border rounded p-2 mt-3 mt-xl-0 h-100'>
            <div className='p-2'>
              <p className='text-center' style={{ fontWeight: "500" }}>Upload selfie with document</p>
              {
                values.uploadedFile_3 ?
                  <div>
                    <div className='d-flex justify-content-center position-relative'>
                      <img src={values.uploadedFile_3.uploadedFile} className='rounded' height={150} />
                    </div>
                    <div className='d-flex justify-content-center mt-3 mb-2'>
                      <Button size='sm' className=' px-3' variant='danger'
                        onClick={() => {
                          setValues(values => ({ ...values, uploadedFile_3: null }))
                        }}
                      >
                        Remove
                      </Button>
                    </div>
                  </div>
                  : <ImageUploadComponent
                    cb={onUploadFile}
                    field='uploadedFile_3'
                  />
              }
            </div>
          </div>
        </Col>
        <Col sm={12} className="d-flex justify-content-end gap-2 mt-3">
          <Button
            variant='secondary'
            onClick={() => {
              setStepNumber(2);
            }}
          >
            Cancel
          </Button>
          {
            isLoading ?
              <Button type='submit' variant="primary" className='px-4' disabled>
                <span className='me-2'>Loading</span>
                <ImSpinner3 className='rotating' />
              </Button>
              : <Button
                disabled={!documentType || !values.uploadedFile_1 || !values.uploadedFile_2 || !values.uploadedFile_3}
                variant="primary"
                type="submit"
              >
                Submit
              </Button>
          }
        </Col>
      </Row>
    </Form>
  )
}
